import React from 'react';
import {render} from 'react-dom';
import NativeLayout from './NativeLayout';
import WebLayout from './WebLayout';
import {isNative} from 'ferries/helpers/common';

const getComponentToRender = () => {
  if (isNative()) {
    return NativeLayout;
  } else {
    return WebLayout;
  }
};

render(
  React.createElement(getComponentToRender()),
  document.getElementById('cms')
);
